import React from 'react';
import { Avatar, Fab } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useTranslation } from 'react-i18next';
// import FullscreenIcon from '@mui/icons-material/Fullscreen'; 
import DownloadBrochure from './DownloadBrochure';
import PhoneIcon from '@mui/icons-material/Phone';
const ScrollToTopButton = ({ whatsApp, phone }) => {
    const { i18n } = useTranslation();

    // const handleScrollToTop = () => {
    //     window.scrollTo({
    //         top: 0,
    //         behavior: 'smooth',
    //     });
    // };
    return (
        <>
            <Fab
                sx={{
                    position: 'fixed',
                    bottom: 20,
                    right: i18n.dir() === 'ltr' ? 16 : 'auto',
                    left: i18n.dir() === 'rtl' ? 16 : 'auto',
                    zIndex: 1000,
                    width: '2rem',
                    height: '2rem',
                    borderRadius: '8px',
                }}>
                <a href={`tel:${phone}`} target='_blank' rel='noreferrer'>
                    <Avatar sx={{
                        backgroundColor: "#25D366", width: '3rem',
                        height: '3rem',
                    }} >
                        <PhoneIcon sx={{
                            width: '2rem',
                            height: '2rem',
                        }} />
                    </Avatar>
                </a>
            </Fab>
            <Fab
                sx={{
                    position: 'fixed',
                    bottom: 75,
                    right: i18n.dir() === 'ltr' ? 16 : 'auto',
                    left: i18n.dir() === 'rtl' ? 16 : 'auto',
                    zIndex: 1000,
                    width: '2rem',
                    height: '2rem',
                    borderRadius: '8px',
                }}>
                <a href={`https://wa.me/${whatsApp}`} target='_blank' rel='noreferrer'>
                    <Avatar sx={{
                        backgroundColor: "#25D366", width: '3rem',
                        height: '3rem',
                    }} >
                        <WhatsAppIcon sx={{
                            width: '2rem',
                            height: '2rem',
                        }} />
                    </Avatar>
                </a>
            </Fab>

            <Fab
                color="#FF4000"
                sx={{
                    position: 'fixed',
                    bottom: 75,
                    right: i18n.dir() === 'rtl' ? 30 : 'auto',
                    left: i18n.dir() === 'ltr' ? 30 : 'auto',
                    zIndex: 1000,
                    width: '0',
                    height: '0',
                    borderRadius: '8px',
                    transform:'rotate(-90deg)'
                }}>
                <DownloadBrochure />
            </Fab>

        </>
    );
};

export default ScrollToTopButton;
